import { LinearProgress } from "@mui/material";
import { planTypeList, policyIcon } from "../../../core/utils";
import {  EmptyTable, Layout, PolicyInfo } from "../../components";
import { InsurancePolicyListController } from "../../controllers";
import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";


class InsurancePolicyList extends InsurancePolicyListController {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.getList();
    // this.props.dispatch(this.getProfile());

  }
  render() {

    const { policiesList,loading } = this.state;
    return (
      <Layout title="بیمه نامه  ">
        <Helmet>
          <title> بیمه نامه | بیمه زندگی هامرز </title>
        </Helmet>

        {loading ?
          <LinearProgress />
          :
                
                <>
  {policiesList?.list?.length === 0 ?
              <EmptyTable title="اطلاعاتی برای نمایش وجود ندارد" />
              :


              <>
              
              
              <div className="insuranc-policy-list scrollbar hide-mobile ">
                {policiesList?.list?.map((item: any, index: number) => {
                  return (
                    <div className="list-item">
      
                      <PolicyInfo icon={policyIcon(item?.insurance_type)} myStyle="custom-border-left" title="بیمه نامه:" subTitle={`${planTypeList.filter((p: { value: string; }) => p.value ===  item?.insurance_type)[0]?.title}`} />
      
                      <PolicyInfo myStyle="custom-border-left" title="شماره بیمه نامه :" subTitle={item.idinsu} />
      
                      <PolicyInfo myStyle="custom-border-left" title="وضعیت بیمه نامه:" subTitle={item?.state} />
      
                      <PolicyInfo title="میزان اندوخته:" subTitle="---" colorful />
      
      
                      {/* <Button myStyle="custom-button" title=" جزئیات بیمه نامه " link={`/insurance-policy-details/${item?.id}`} /> */}
      
                    </div>
                  )
                })}
              </div>
      
              <div className="insuranc-policy-list hide-desktop">
                {policiesList?.list?.map((item: any, index: number) => {
                  return (
                    <>
                      <div className="insuranc-policy-list-mobile-row ">
                        <PolicyInfo myStyle="" title="بیمه نامه:" subTitle={`${planTypeList.filter((p: { value: string; }) => p.value ===  item?.insurance_type)[0]?.title}`} />
                        <PolicyInfo myStyle="" title="شماره بیمه نامه :" subTitle={item.idinsu} />
                        <div className="d-flex">
                          <PolicyInfo myStyle="custom-border-left" title="وضعیت بیمه نامه:" subTitle={item?.state} />
                          <PolicyInfo myStyle="pe-3" title="میزان اندوخته:" subTitle={"---"} colorful />
                        </div>
                        {/* <Button myStyle="custom-button" title=" جزئیات بیمه نامه " link={`/insurance-policy-details/${item?.id}`} /> */}
                      </div>
                    </>
                  )
                })}
              </div>
              </>
            }
                </>
  } 
      </Layout>
    )
  }
}
const mapStateToProps = (dispatch: any) => {
  return {
    dispatch,
    userData: dispatch.general.userData,
  }
};

export default connect(mapStateToProps)(InsurancePolicyList);